import React from 'react';
import { Provider } from 'react-redux';
import createStore from './createStore';

const StateProvider = ({ children }) => (
  <Provider store={createStore()}>{children}</Provider>
);

export default StateProvider;
